import { ApplicationType } from '../types/translation-types';
import { LanguageManagementRepository } from '../data/language-management-repository';
import {
  SetApplicationLanguagesRequest,
  SetApplicationLanguagesResponse,
} from '../types/language-management-types';

/**
 * Set Application Languages Use Case
 * Sets which languages an application should support
 */
export class SetApplicationLanguagesUseCase {
  constructor(private readonly repository: LanguageManagementRepository) {}

  async execute(
    applicationType: ApplicationType,
    languageIds: number[]
  ): Promise<SetApplicationLanguagesResponse> {
    const request: SetApplicationLanguagesRequest = {
      languageIds,
    };
    return this.repository.setApplicationLanguages(applicationType, request);
  }
}
